class DeliveryEstimates extends HTMLElement {
	constructor() {
		super();

		this.allDeliveryEstimates = Array.from(this.children).filter(
			(child) => child.localName === 'delivery-estimate-template'
		);

		const isOnCart = this.hasAttribute('on-cart');

		if (isOnCart) {
			// Way to overcome a bug when cart contents are created as a HTMLFragment
			document.addEventListener('cart:refresh', () => {
				for (let i = 0; i < this.allDeliveryEstimates.length; i++) {
					const deliveryEstimate = this.allDeliveryEstimates[i];
					if (typeof deliveryEstimate.calculate === 'function') {
						deliveryEstimate.calculate();
					}
				}
				this.displayEstimates();
			});
			return;
		}

		for (let i = 0; i < this.allDeliveryEstimates.length; i++) {
			const deliveryEstimate = this.allDeliveryEstimates[i];
			deliveryEstimate.calculate();
		}
		this.displayEstimates();
	}

	displayEstimates() {
		const displayEstimatesAmount = parseInt(
			this.getAttribute('display-amount'),
			10
		);

		if (!displayEstimatesAmount) {
			this.removeAttribute('hidden');
			return;
		}

		this.displayByStrategy(this.getAttribute('display-strategy'));
		this.removeAttribute('hidden');
	}

	displayByStrategy(strategy) {
		if (strategy === 'fastest-delivery') {
			this.hideAllDeliveryEstimates();
			this.displayFastestDelivery();
		}
	}

	hideAllDeliveryEstimates() {
		this.allDeliveryEstimates.forEach((deliveryEstimate) =>
			deliveryEstimate.setAttribute('hidden', true)
		);
	}

	displayFastestDelivery() {
		const maximumDeliveryTimes = this.allDeliveryEstimates.map(
			(deliveryEstimate) =>
				parseInt(
					deliveryEstimate.getAttribute('maximum-delivery-time'),
					10
				)
		);

		const fastestDeliveryEstimateIndex = maximumDeliveryTimes.reduce(
			(minIndex, currentValue, currentIndex, deliveryEstimates) =>
				currentValue < deliveryEstimates[minIndex]
					? currentIndex
					: minIndex,
			0
		);

		const fastestDeliveryEstimate =
			this.allDeliveryEstimates[fastestDeliveryEstimateIndex];
		fastestDeliveryEstimate.removeAttribute('hidden');
	}
}

customElements.define('delivery-estimates', DeliveryEstimates);
